/**
 * Extracts and returns details of failed validation rules for a given item.
 * Each failed rule includes the affected fields, rule name, description and type.
 *
 * @param {Object} item - The data item containing __validationResults__, typically a data row in an entity.
 * @param {Object} validationRules - The object containing all available validation rules for the entity.
 * @returns {Array} Array of failed field rule details.
 */
export const getFailedValidationFields = (item, validationRules) => {
  const failedFields = [];

  item.__validationResults__.map(result => {
    if (!result.RulePassed) {
      const validationRule = validationRules.ValidationRules.find(rule => {
        return rule.EntityValidationRuleGuid === result.EntityValidationRuleGuid;
      });
      const fields = validationRule?.LogicTree.Expressions.map(expression => {
        return expression.LeftHandSide.value;
      });
      if (validationRule) {
        failedFields.push({
          fields: fields,
          warning: validationRule.RuleName,
          description: validationRule.RuleDescription,
          type: validationRule.ValidationRuleType,
        });
      }
    }
  });
  
  return failedFields;
};